import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-m-applied-filters',
    templateUrl: './m-applied-filters.component.html',
    styleUrls: ['./m-applied-filters.component.scss'],
    preserveWhitespaces: true
})
export class MAppliedFiltersComponent {

    @Input() filters: Array<string> = [];

    constructor() {
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/components/applied-filters/m-applied-filters.component.ts